module.exports = __webpack_public_path__ + "img/mnms1.dab0de8e.png";